module.exports = __webpack_public_path__ + "static/media/alps.332f6604.png";